import { createWorkerClient } from "./worker-client";

/**
 * Analyzer Worker を classic worker として起動する (§5.7)。
 *
 * Worker は scripts/build-worker.mjs (esbuild) で `format: 'iife'` の単独 bundle として
 * 事前ビルドされ、 `public/vendor/analyzer.worker-<hash>.js` として配置される。
 * dev (`pnpm dev`) / production preview / production build (`vite build` 経由) のすべてで
 * 同一の classic worker bundle が動作する (Vite 8 dev での worker module 化問題を回避)。
 *
 * ファイル名の hash は `analyzer.worker.manifest.json` 経由で vite.config.ts が
 * `__WORKER_FILE__` として main bundle に inject する。 内容変更時に hash が変わるため
 * CDN / proxy / browser cache がすべて自動的に bust される。
 *
 * 詳細は scripts/build-worker.mjs / vite.config.ts のコメント参照。
 *
 * Worker のソース (src/workers/) を変更したら `pnpm build:worker` で再ビルドする
 * (`pnpm dev` / `pnpm build` の起動時に自動で走る)。
 */

declare const __WORKER_FILE__: string;

export function createAnalyzerWorker() {
  return createWorkerClient(() => new Worker(`${location.origin}/vendor/${__WORKER_FILE__}`));
}
